var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"referred-job-info-item"},[_vm._t("default"),_c('span',{staticClass:"paragraph-s paragraph-dark-gray"},[_vm._v(_vm._s(_vm.props.text))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }